export default {
  setStartLoadingTranslatedString(state, { sourceLanguage, sourceText }) {
    const translateKey = `${sourceLanguage}-${sourceText}`
    if (!state.translatedStringLoading.includes(translateKey)) {
      state.translatedStringLoading.push(translateKey)
    }
  },
  setEndLoadingTranslatedString(state, { sourceLanguage, sourceText }) {
    const translateKey = `${sourceLanguage}-${sourceText}`
    if (state.translatedStringLoading.includes(translateKey)) {
      state.translatedStringLoading = state.translatedStringLoading.filter(
        el => el !== translateKey,
      )
    }
  },
  addTranslatedString(
    state,
    { sourceLanguage, sourceText, targetLanguage, targetText },
  ) {
    const translateKey = `${sourceLanguage}-${sourceText}`
    let translations = {
      ...(state.translatedStrings?.[translateKey] || {}),
      [targetLanguage]: targetText,
    }

    const newTranslatedStrings = {
      ...state.translatedStrings,
      [translateKey]: {
        ...translations,
      },
    }

    state.translatedStrings = { ...newTranslatedStrings }
  },
}
